module.exports = __webpack_public_path__ + "static/media/map-one-argentinian.6954b959.svg";